import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

const SIZE = {
  sm: 'h-4 min-w-4 px-1 text-3xs',
  default: 'h-5 min-w-5 px-1.5 text-xs',
} as const;

/**
 * A key on the keyboard, in a hint or a shortcuts list: `Press <Kbd>j</Kbd> for the next one`.
 * sm (16px) inside a field or a button, as the search box's Ctrl+K; default (20px) in text and lists.
 */
export function Kbd({
  children,
  size = 'default',
  className,
}: {
  children: ReactNode;
  size?: keyof typeof SIZE;
  className?: string;
}) {
  return (
    <kbd
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded border bg-muted font-mono leading-none font-medium text-muted-foreground',
        SIZE[size],
        className
      )}
    >
      {children}
    </kbd>
  );
}
